export default class Project {
    constructor(adapter) {
        this.adapter = adapter
    }

    workflow(name) {
        return new ProjectWorkflow(this.adapter.getWorkflowApi(), name)
    }

    async currentProject() {
        return await this.adapter.getStore().getters.getCurrentProject
    }
}

class ProjectWorkflow {
    constructor(workflowApi, name) {
        this.workflowApi = workflowApi
        this.name = name
    }

    async trigger(event, data) {
        return await this.workflowApi.post("/workflow/"+this.name+"/event/" + event, data)
    }
}